module.exports = __webpack_public_path__ + "img/training.98e30dcb.png";